export default __webpack_public_path__ + "static/media/wol-chapter4-image.0ee243d7.jpg";